export default __webpack_public_path__ + "static/marblesorter-6bd6ce73a60515ad74bc903e361f2f72.jpg";